import { useState, useEffect, useRef } from "react";

import { Button, Input, Label } from "@/components";

import { Copy, CopyCheck, ArrowRight, Zap } from "lucide-react";

import QRCodeStyling from "qr-code-styling";



export default function WhatsAppLinkGenerator() {

  const [phoneNumber, setPhoneNumber] = useState("");

  const [message, setMessage] = useState("");



  const [generatedLink, setGeneratedLink] = useState("");

  const [copied, setCopied] = useState(false);

  const [phoneError, setPhoneError] = useState("");

  const [email, setEmail] = useState("");

  const [emailError, setEmailError] = useState("");



  const qrCode = useRef<QRCodeStyling | null>(null);

  const qrRef = useRef<HTMLDivElement | null>(null);



  useEffect(() => {

    qrCode.current = new QRCodeStyling({

      width: 200,

      height: 200,

      data: "",

      margin: 12,

      dotsOptions: {

        color: "#0a0a0a",

        type: "rounded",

      },

      backgroundOptions: {

        color: "#ffffff",

      },

      cornersSquareOptions: {

        type: "extra-rounded",

        color: "#000000",

      },

      cornersDotOptions: {

        type: "dot",

        color: "#000000",

      },

    });

  }, []);



  useEffect(() => {

    if (!qrRef.current || !qrCode.current) return;



    // 1. clear previous QR

    qrRef.current.innerHTML = "";



    // 2. append FIRST

    qrCode.current.append(qrRef.current);



    // 3. then update data

    if (generatedLink) {

      qrCode.current.update({

        data: generatedLink,

      });

    }

  }, [generatedLink]);



  // const downloadQR = () => {

  //   if (!qrCode.current) return;



  //   qrCode.current.download({

  //     name: "whatsapp-qr",

  //     extension: "png",

  //   });

  // };



  const generateLink = () => {

    let isValid = true;



    if (!phoneNumber.trim()) {

      setPhoneError("Phone number is required");

      isValid = false;

    } else {

      setPhoneError("");

    }



    if (!email.trim()) {

      setEmailError("Business email is required");

      isValid = false;

    } else if (!validateEmail(email)) {

      setEmailError("Enter a valid business email");

      isValid = false;

    } else {

      setEmailError("");

    }



    if (!isValid) return;



    const formattedPhone = phoneNumber.replace(/[^\d]/g, "");



    let finalMessage = message || "Hello! I'd like to connect with you...";



    finalMessage += `\nEmail: ${email}`;



    const encodedMessage = encodeURIComponent(finalMessage);



    const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;



    setGeneratedLink(whatsappUrl);

  };

  const validateEmail = (email: string) => {

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;



    if (!emailRegex.test(email)) return false;



    return true;

  };



  const copyToClipboard = () => {

    if (generatedLink) {

      navigator.clipboard.writeText(generatedLink);

      setCopied(true);

      setTimeout(() => setCopied(false), 2000);

    }

  };



  return (

    <form

      onSubmit={(e) => {

        e.preventDefault();

        generateLink();

      }}

      className="flex flex-col gap-6"

    >
      <div>
        <div className="bg-white dark:bg-gray-800 rounded-md shadow-sm border border-gray-200 dark:border-gray-700 p-6 flex flex-col gap-4">

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

            {/* WhatsApp Number Input */}

            <div>

              <Label htmlFor="whatsapp-number">

                WhatsApp Number (with country code, without + symbol)

              </Label>

              <Input

                id="whatsapp-number"

                type="tel"

                value={phoneNumber}

                onChange={(e) => {

                  const value = e.target.value;

                  setPhoneNumber(value);



                  if (value.trim()) {

                    setPhoneError("");

                  }

                }}

                onKeyDown={(e) => {

                  if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {

                    e.preventDefault();

                  }

                }}

                placeholder="1234567890"

                className="w-full"

              />

              {phoneError && (

                <p className="text-sm text-red-500 mt-1">{phoneError}</p>

              )}

            </div>



            {/* Business Email Input */}

            <div>

              <Label htmlFor="business-email">Enter your Business Email ID</Label>

              <Input

                id="business-email"

                type="email"

                value={email}

                onChange={(e) => {

                  const value = e.target.value;

                  setEmail(value);



                  if (!value.trim()) {

                    setEmailError("Business email is required");

                  } else if (!validateEmail(value)) {

                    setEmailError("Enter a valid business email");

                  } else {

                    setEmailError("");

                  }

                }}

                placeholder="business@company.com"

                className="w-full"

              />

              {emailError && (

                <p className="text-sm text-red-500 mt-1">{emailError}</p>

              )}

            </div>

          </div>

          {/* Pre-filled Message Input */}

          <div>

            <Label htmlFor="message">Pre-filled Message (Optional)</Label>

            <textarea

              id="message"

              value={message}

              onChange={(e) => setMessage(e.target.value)}

              placeholder="Hello! I'd like to connect with you..."

              rows={4}

              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white resize-none"

            />

          </div>



          {/* Generate Button */}

          <Button type="submit" className="ms-auto flex items-end justify-end">

            Generate WhatsApp Link

          </Button>
        </div>


        {/* Generated Link Display */}

        {generatedLink && (
          <div className="flex flex-col gap-6 mt-6">

            <div className="flex flex-col lg:flex-row justify-between w-full gap-6 bg-white p-6 rounded-md border border-gray-200 dark:border-gray-600 dark:bg-gray-800">
              <div className="flex flex-col gap-4 w-full">

                <div className="flex flex-col gap-1">
                  <h3 className="text-gray-900 dark:text-gray-100 font-bold">Your Generated Link</h3>
                  <div className="flex justify-between w-full px-3 py-2.5 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-500 rounded-sm text-sm text-gray-700 dark:text-gray-200">
                    <input

                      type="text"

                      value={generatedLink}

                      readOnly

                      className="w-full"

                    />

                    <button
                      type="button"

                      onClick={copyToClipboard}

                      className={`shrink-0 flex gap-2 items-center justify-center px-2 lg:px-4 py-2 rounded-sm border transition-all duration-300 ${copied ? "bg-green-50 border-green-300 text-green-600 dark:bg-green-900/30 dark:border-green-600 dark:text-green-400" : "bg-[#025d4b] text-white dark:border-[#025d4b]"}`}

                      title={copied ? "Copied!" : "Copy to clipboard"}

                    >

                      {copied ? (

                        <span className="flex items-center gap-2"> <CopyCheck strokeWidth={2.5} className="w-4 h-4" /><span className="hidden lg:block">Copied</span></span>

                      ) : (

                        <span className="flex items-center gap-2"> <Copy strokeWidth={2.5} className="w-4 h-4" /><span className="hidden lg:block">Copy</span> </span>

                      )}

                    </button>
                  </div>
                </div>

                <div className="divider flex items-center">
                  <hr className="flex-1 border-t border-gray-300 dark:border-gray-600" />
                  <span className="text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap px-2">OR</span>
                  <hr className="flex-1 border-t border-gray-300 dark:border-gray-600" />
                </div>

                <div className="bg-green-50 dark:bg-green-600/10 rounded-md border border-[#025d4b]/20 dark:border-gray-700 p-4">
                  <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-6">
                    <div className="flex flex-col lg:flex-row lg:items-center gap-3">
                      <div className="max-w-12 w-12 h-12 bg-[#025d4b] rounded-full flex items-center justify-center shadow-lg">
                        <Zap color="white" />
                      </div>
                      <div className="flex flex-col gap-1">
                        <h3 className="font-bold text-gray-900 dark:text-white">Automate conversations when someone clicks your link</h3>
                        <p className="text-xs text-gray-600 dark:text-gray-400">TheQuickAssist handles instant auto-replies, lead capture, and full WhatsApp CRM.</p>
                      </div>
                    </div>

                    <Button
                      onClick={() => window.open(generatedLink, "_blank")}
                      className="flex items-center gap-2 bg-[#025d4b] hover:text-white hover:border-[#025d4b] text-white  transform hover:scale-105 transition-all duration-300 rounded-full font-semibold"
                    >
                      Start free <ArrowRight size={16} />
                    </Button>
                  </div>
                </div>
              </div>

              <div className="flex-1 flex items-center justify-center">

                <div ref={qrRef} className="bg-white rounded-sm p-2 border border-gray-200" />

                {/* <Button onClick={downloadQR} className="text-sm">

                  Download QR Code

                </Button> */}

              </div>
            </div>

          </div>

        )}

      </div>

    </form>

  );

}

